import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Http } from '@angular/http';
import { Component, OnInit } from '@angular/core';
import { ConfigsService } from '../../configs.service';
declare var swal;
declare var $:any;

@Component({
  selector: 'app-recuperar-senha',
  templateUrl: './recuperar-senha.component.html',
  styleUrls: ['./recuperar-senha.component.css']
})
export class RecuperarSenhaComponent implements OnInit {
  
  logo:string;
  corPadrao:string;

  dataAtual:any = new Date();
  anoAtual:any = this.dataAtual.getFullYear();  
  
  constructor(private http:Http, 
              private config:ConfigsService, 
              private rota:Router,
              private titulo:Title) {
    this.titulo.setTitle("Novo Acesso - "+this.config.nome);
    this.logo = config.logo;
    this.corPadrao = config.corPadrao;  
  }

  listaEstados:any = ["AC", "AL", "AM", "AP", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN", "RO", "RS", "RR", "SC", "SE", "SP", "TO"]
  
  enviaSenha(form){
    $.bloqueiaTela();
    this.http.post(`${this.config.urlApi}/medicos/recuperaSenha`, form.value)
      .subscribe(data => {
        
        var dados = data.json();
        console.log(dados);
        $.desbloqueiaTela();
        if(dados.status == 1){          
          swal("Sucesso!", dados.msg, "success")
            .then(d => {
              this.rota.navigate(["/login"]);
            });
        }else{
          swal("Oops!", dados.msg, "warning");
        }
      });
    // console.log(dados);
  }
  


  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/login/recuperar-senha/recuperar-senha.component.ts